import { Observer } from 'mobx-react';
import * as React from 'react';

import { ConfirmModal } from 'src/modules/transferRegistration/components/ConfirmModal';
import { openConfirmModalStore } from 'src/modules/transferRegistration/stores';

export const BaseConfirm = () => {
  return <Observer>{() => (openConfirmModalStore.value ? <ConfirmModal open={openConfirmModalStore.value} /> : null)}</Observer>;
};
